export default "__VITE_ASSET__CI$Xezy8__"